import React, { useState, useEffect } from 'react';

import { DataUsage, ArrowUpward, ArrowDownward, AssignmentTurnedIn } from '@material-ui/icons';

import i18n from 'i18n-js';
import { sortBy } from 'lodash';
import { buildUrl } from 'utils';
import PropTypes from 'prop-types';
import { usePrevious } from 'hooks';
import { TotalCard } from 'components/UI';
import { useStyles } from './Actions.styled';
import { useHistory } from 'react-router-dom';
import { Grid, SvgIcon, Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { DashboardActions } from 'state/modules/dashboard';

const ActionsTotalsCards = ({ parameters, onRefresh, handleRefresh }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const prevCustomParams = usePrevious(parameters);
  const [params, setParams] = useState({ ...parameters });
  const prevParams = usePrevious(params);

  const { actionsTotals } = useSelector((state) => state.dashboard);

  const getTotals = (params) => {
    Object.keys(params).forEach(
      (key) =>
        (!params[key] || params[key] === undefined || params[key] === null) && delete params[key]
    );
    dispatch(DashboardActions.fetchQualsActionsTotals(params));
  };

  useEffect(() => {
    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      getTotals(params);
    }
  }, [params]); // eslint-disable-line

  useEffect(() => {
    if (JSON.stringify(prevCustomParams) !== JSON.stringify(parameters)) {
      setParams({
        ...params,
        ...parameters,
      });
    }
  }, [parameters, prevCustomParams]); // eslint-disable-line

  useEffect(() => {
    if (onRefresh) {
      getTotals(params);
      handleRefresh();
    }
  }, [onRefresh]); // eslint-disable-line

  const getLinkFromSourceType = (action) => {
    let path = '';
    if (params.source_type === 'User') {
      path = 'customers';
    } else if (params.source_type === 'Subscription') {
      path = 'subscriptions';
    } else {
      return '';
    }
    return `/${path}?status_detail=${action}`;
  };

  const setTotalCardData = (data) => {
    let path = null;
    let icon = DataUsage;
    let color = 'primary';
    let className = null;
    const action = data.details;
    switch (action) {
      case 'NEEDSAPPROVAL':
        icon = AssignmentTurnedIn;
        color = 'success';
        path = getLinkFromSourceType(action);
        break;
      case 'SCHEDULEDELIVERY':
        icon = ArrowUpward;
        className = 'bordered';
        path = `/subscriptions?status_detail=${action}`;
        break;
      case 'MARKASDELIVERED':
        icon = ArrowUpward;
        className = 'bordered';
        path = `/subscriptions?status_detail=${action}`;
        break;

      case 'MARKASRETURNED':
        icon = ArrowDownward;
        color = 'warning';
        className = 'bordered';
        path = `/subscriptions?status_detail=${action}`;
        break;
      default:
        break;
    }
    return {
      path,
      icon,
      color,
      className,
      count: data.count,
      label: `${i18n.t(`qualsActions.${action}`, { defaultValue: action })}`,
    };
  };

  return (
    <Grid container spacing={2}>
      {actionsTotals?.length > 0 &&
        sortBy(actionsTotals, 'details').map((action, i) => {
          const data = setTotalCardData(action);
          return (
            <Grid item xs={12} sm={12} md={6} lg={3} key={i}>
              <TotalCard
                label={data.label}
                count={data.count}
                color={data.color}
                showLinkButton={data?.path ? true : false}
                onClick={() => (data?.path ? history.push(buildUrl(data?.path)) : {})}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  className={data.className ? classes[data.className] : undefined}
                >
                  <SvgIcon component={data?.icon} />
                </Box>
              </TotalCard>
            </Grid>
          );
        })}
    </Grid>
  );
};

ActionsTotalsCards.propTypes = {
  parameters: PropTypes.object.isRequired,
};

ActionsTotalsCards.defaultProps = {
  parameters: {},
};

export default ActionsTotalsCards;
